<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?type=design&node-id=3-2&mode=design&t=xbBsSuLClmXXxdRX-0-->
<template>
  <blockquote class="quote">
    <div class="quote__text">
      <TheContent
        v-for="item of quoteText"
        :key="item.id"
        :elem="item"
      />
    </div>
    <div class="quote__title">
      <TheContent
        v-for="item of quote.title"
        :key="item.id"
        :elem="item"
      />
    </div>
    <div class="quote__details">
      <TheContent
        v-for="item of quote.details"
        :key="item.id"
        :elem="item"
      />
    </div>
  </blockquote>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { QuoteAttributes } from '~/types/components/BQuote';
  import TheContent from '~/components/content/TheContent';

  export default defineNuxtComponent({
    name: 'BQuote',

    components: {
      TheContent,
    },

    props: {
      elem: {
        type: Object as PropType<TContent<QuoteAttributes>>,
        required: true,
      },
    },

    computed: {
      quote(): QuoteAttributes {
        return this.elem.attributes;
      },

      quoteText(): TContent[] {
        return this.elem.children;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .quote {
    margin: 24px 0;
    padding: 24px 8px 32px;

    @include tablet {
      padding: 24px 16px 32px;
    }

    @include quoteIcon;

    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;

    &__text {
      @include bigText;
      font-weight: 500;
      margin-bottom: 16px;
    }

    &__title {
      @include normalText;
      font-family: $secondFont;
      font-weight: 600;
      margin-bottom: 4px;

      @include tablet {
        @include mediumText;
      }
    }

    &__details {
      @include normalText;
    }
  }
</style>
